/*
 *
 * GcIllustrationPage reducer
 *
 */

import { fromJS } from 'immutable';
import {
  CHANGE_LIFE_ASSURED_ACTION,
  CHANGE_CHILD_LIFE_ASSURED_ACTION,
  CHANGE_PRODUCT_CONFIG_ACTION,
  SET_PRODUCT_CONFIG_ACTION,
  SET_QUOTE_ACTION,
  SET_CALCULATION_ACTION,
  SET_ERROR_ACTION,
  SET_COVERAGES_LIST_ACTION,
  SET_QUOTE_DETAILS_ACTION,
  RESET_ACTION,
  SET_APPLICATION_ID_ACTION,
  SET_GC_CONFIG_ACTION,
  SET_FIA_ACTION,
  SET_BI_TABLE_VALUES_ACTION,
  SET_BI_TABLE_VALUES_ACTION1,
  SET_CLONE_STATUS_ACTION,
  SET_BI_PDF_ACTION,
  SET_PTV_VERSION_ACTION,
  SET_CONFIG_NAME_ACTION,
  SET_EMAIL_SENT_ACTION,
  SET_EMAIL_ERROR_MESSAGE_ACTION,
  SET_COVERAGES_LIST2_ACTION,
  SET_BI_PDF_ACTION1,
  SET_COVERAGES2_ACTION,
  SET_PRODUCT_CODE_ACTION,
} from './constants';
import { getStartDate } from './helper';

const defaultState = {
  emailErrorMessage: '',
  emailSent: false,
  quoteId: '',
  applicationId: '',
  referenceNumber: '',
  benefitIllustrationPdf: '',
  status: '',
  errorData: {
    error: false,
    message: [],
  },
  lifeAssured: {
    insuredOne: {
      prospectId: '',
      title: '',
      firstName: '',
      lastName: '',
      countryOfResidence: '',
      dateOfBirth: '',
      nationality: 'Select an option',
      gender: '',
      isSmoke: null,
      isLifeInsured: true,
      isPrimaryLifeInsured: true,
      isPolicyOwner: true,
      relationshipToLifeInsured: 'Select an option',
    },
    childDetails: {
      prospectId: '',
      title: '',
      firstName: '',
      lastName: '',
      dateOfBirth: '',
      countryOfEducation: 'Select an option',
      otherUniversityCountryCode: 'Select an option',
      otherUniversityCountryName:'',
      calculatedUniversityFee:0,
      universityFeeUpdated:false,
      countryOfResidence: '',
      nationality: 'Select an option',
      gender: '',
      currency: 'Select',
      isSmoke: null,
      isLifeInsured: true,
      isPrimaryLifeInsured: true,
      isPolicyOwner: false,
      payoutYears:'',
      relationshipToLifeInsured: 'CHILD',
    },
    isInsuredTwo: false,
    insuredTwo: {
      prospectId: '',
      title: '',
      firstName: '',
      lastName: '',
      dateOfBirth: '',
      countryOfResidence: '',
      nationality: 'Select an option',
      gender: '',
      isSmoke: null,
      isLifeInsured: true,
      isPolicyOwner: false,
      isPrimaryLifeInsured: false,
      relationshipToLifeInsured: 'Select an option',
    },
    isPolicyOwnerIndividual: false,
    policyOwnerIndividual: [
      {
        prospectId: '',
        firstName: '',
        lastName: '',
        relationshipToLifeInsured: 'Select an option',
        isPolicyOwner: true,
        isLifeInsured: false,
        isPrimaryLifeInsured: false,
      },
    ],
  },
  childDetails: {
    prospectId: '',
    title: '',
    firstName: '',
    lastName: '',
    countryOfResidence: '',
    dateOfBirth: '',
    nationality: 'Select an option',
    otherUniversityCountryCode: 'Select an option',
    otherUniversityCountryName:'',
    gender: '',
    payoutYears:'',
    isSmoke: null,
    isLifeInsured: true,
    isPrimaryLifeInsured: true,
    isPolicyOwner: false,
    relationshipToLifeInsured: 'CHILD',
  },
  productConfig: {
    name: 'Education Savings Plan',
    productCode: 'ESP01',
    ptvVersion: '',
    calculatedUniversityFee:0,
    specialTermsFlag: false,
    fiaCharge: 0,
    startDate: getStartDate().format('YYYY-MM-DD'),
    currency: 'Select',
    term: 'Select',
    paymentFrequency: 'Select',
    payoutYears: 'Select',
    offerCode: '',
    premium: 0,
    growthRate: '',
    coverages: [],
    withdrawalFrequency: 'Yearly',
    isEducationalFeeWithdrawal: false,
    isRegularWithdrawal: false,
    isBundlingQuote: false,
    targetFunctionality: true,
    isTargetFundProtectionLifeOne: true,
    isTargetFundProtectionLifeTwo: true,
    regularWithdrawal: {
      frequency: 'Select',
      startDate: '',
      endDate: '',
      amount: 0,
      percentage: 0,
      isAmountChecked: 1,
    },
    educationFeesWithdrawal: {
      child1: {
        frequency: 'Select',
        startDate: '',
        endDate: '',
        amount: 0,
        firstName: '',
        lastName: '',
        percentage: 0,
        isAmountChecked: 1,
      },
    },
  },
  productConfig2: { premium: 0, coverages: [] },
  biTableValues: {},
  biTableValues1: {},
  gcConfig: {},
  fiaData: {},
  initialLifeAssured: {},
  initialProductConfig: {},
  successClone: false,
  coverages2: [], //from api only
};

export const initialState = fromJS({ ...defaultState });

function espIllustrationPageReducer(state = initialState, action) {
  switch (action.type) {
    case SET_ERROR_ACTION:
      return state.set('errorData', fromJS(action.payload));
    case RESET_ACTION:
      return fromJS({ ...defaultState });
    case SET_QUOTE_ACTION:
      return state.set('quoteId', action.payload);
    case SET_APPLICATION_ID_ACTION:
      return state.set('applicationId', action.payload);
    case SET_GC_CONFIG_ACTION:
      return state.set('gcConfig', fromJS(action.payload));
    case SET_BI_TABLE_VALUES_ACTION:
      return state.set('biTableValues', fromJS(action.payload));
    case SET_BI_TABLE_VALUES_ACTION1:
      return state.set('biTableValues1', fromJS(action.payload));
    case CHANGE_CHILD_LIFE_ASSURED_ACTION:
      return state
        .set('childDetails', fromJS(action.payload))
        .setIn(
          ['lifeAssured', 'childDetails'],
          fromJS(action.payload))
        .setIn(
          ['initialLifeAssured', 'childDetails'],
          fromJS(action.payload));
    case CHANGE_LIFE_ASSURED_ACTION:
      return state
        .set('lifeAssured', fromJS(action.payload))
        .set('initialLifeAssured', fromJS(action.payload));
    case CHANGE_PRODUCT_CONFIG_ACTION:
      return state
        .set('productConfig', fromJS(action.payload))
        .set('initialProductConfig', fromJS(action.payload));
    case SET_PRODUCT_CONFIG_ACTION:
      return state
        .set('productConfig', fromJS(action.payload.data))
        .set('initialProductConfig', fromJS(action.payload.data));
    case SET_QUOTE_DETAILS_ACTION:
      return (
        state
          .set('referenceNumber', action.payload.referenceNumber)
          //.set('benefitIllustrationPdf', action.payload.benefitIllustrationPdf)
          .set('status', action.payload.status)
      );
    case SET_COVERAGES_LIST_ACTION:
      return state.setIn(
        ['productConfig', 'coverages'],
        fromJS(action.payload),
      );
    case SET_COVERAGES_LIST2_ACTION:
      return state.setIn(
        ['productConfig2', 'coverages'],
        fromJS(action.payload),
      );
    case SET_PTV_VERSION_ACTION:
      return state.setIn(['productConfig', 'ptvVersion'], action.payload);
    case SET_PRODUCT_CODE_ACTION:
      return state.setIn(['productConfig', 'productCode'], action.payload);
    case SET_CONFIG_NAME_ACTION:
      return state.setIn(['productConfig', 'name'], action.payload);
    case SET_CALCULATION_ACTION:
      return state.setIn(['productConfig2', 'premium'], action.payload);
    case SET_FIA_ACTION:
      return state.set('fiaData', fromJS(action.payload));
    case SET_CLONE_STATUS_ACTION:
      return state.set('successClone', action.payload);
    case SET_BI_PDF_ACTION:
      return state.set('benefitIllustrationPdf', action.payload);
    case SET_BI_PDF_ACTION1:
      return state.set('benefitIllustrationPdf1', action.payload);
    case SET_EMAIL_SENT_ACTION:
      return state.set('emailSent', action.payload);
    case SET_EMAIL_ERROR_MESSAGE_ACTION:
      return state.set('emailErrorMessage', action.payload);
    case SET_COVERAGES2_ACTION:
      return state.set('coverages2', fromJS(action.payload));
    default:
      return state;
  }
}

export default espIllustrationPageReducer;
